export default function LockIcon({ color }) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_891_409)">
        <path
          d="M18.7778 9.99998H3.22222C1.99492 9.99998 1 10.8954 1 12V19C1 20.1045 1.99492 21 3.22222 21H18.7778C20.0051 21 21 20.1045 21 19V12C21 10.8954 20.0051 9.99998 18.7778 9.99998Z"
          stroke={color || "#959595"}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.44446 10V6C5.44446 4.67392 6.02977 3.40215 7.07164 2.46447C8.11351 1.52678 9.52659 1 11 1C12.4734 1 13.8865 1.52678 14.9284 2.46447C15.9703 3.40215 16.5556 4.67392 16.5556 6V10"
          stroke={color || "#959595"}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_891_409">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
